import { useEffect, useState } from "react";
import { api } from "./api";

export function useFetch(path, fallback = null) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(path)
      .then((r) => { if (alive) setData(r.data ?? fallback); })
      .catch(() => { if (alive) setData(fallback); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);
  return { data, loading, setData };
}
